export { ensureConsistentKey, ensureConsistentResponses } from './languages';
